import React, { useEffect, useState } from "react";
import Header from './componants/Header/Header';
import SubscriptionPopup from './componants/SubscriptionPopup';
import { useNavigate, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

  const publicPages = ["/", "/forgotpassword", "/register"];
  const isPublicPage = publicPages.includes(location.pathname);

  useEffect(() => {
    const checkSubscription = () => {
      const status = localStorage.getItem("subscription");
      if (status === "Expired" && !isPublicPage) {
        setShowSubscriptionPopup(true);
      } else {
        setShowSubscriptionPopup(false);
      }
    };

    // Check immediately on mount and when location changes
    checkSubscription();

    // Listen for changes in localStorage
    const handleStorageChange = (event) => {
      if (event.key === "subscription") {
        checkSubscription();
      }
    };

    // Listen for custom subscription change event
    const handleSubscriptionChange = () => {
      checkSubscription();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("subscriptionChanged", handleSubscriptionChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("subscriptionChanged", handleSubscriptionChange);
    };
  }, [location.pathname, isPublicPage]);

  const handleExtend = () => {
    window.open("https://www.localshouts.com/", "_blank");
  };

  const handleLogout = () => {
    localStorage.removeItem("subscription");
    localStorage.removeItem("token");
    setShowSubscriptionPopup(false);
    navigate("/");
  };

  return (
    <div id='app'>
      <Header />
      <main id="middle">{children}</main>

      {showSubscriptionPopup && (
        <SubscriptionPopup onExtend={handleExtend} onLogout={handleLogout} />
      )}
    </div>
  );
};

export default Layout;
